"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as e } from "react";
import i from "../components/Icon/SvgIcon.js";
const a = (o) => /* @__PURE__ */ l(
  i,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.771 4.16a2.77 2.77 0 0 0-2.765 2.588l9.073 6.14a1.54 1.54 0 0 0 1.595-.002l9.32-6.14a2.773 2.773 0 0 0-2.765-2.586H4.77ZM22 8.238l-5.962 3.928L22 16.864zm-.26 9.99a.6.6 0 0 1-.127-.077l-6.638-5.23-.035-.03-1.586 1.045-.017.01a2.79 2.79 0 0 1-2.924 0l-.014-.009-.009-.006-1.176-.796-6.904 5.197a2.77 2.77 0 0 0 1.93 1.447q.27.053.548.054h14.424q.278 0 .548-.054a2.77 2.77 0 0 0 1.98-1.55ZM2 17.002l6.12-4.607L2 8.253v8.748Z",
        clipRule: "evenodd"
      }
    )
  }
), d = e(a);
export {
  d as MailFilled,
  d as default
};
